export const useCssUnitProperty = value => {
  const defaultSuffix = 'px';
  return isNaN(Number(value)) ? value : value + defaultSuffix;
};
